<template>
  <div>
    <div v-if="selectedMessages.length > 0" class="multi-message-toolbar">

      <!-- Hiển thị số lượng tin nhắn đã chọn -->
      <div class="selected-count">
        {{ selectedMessages.length }} tin nhắn được chọn
      </div>

      <!-- Thanh action ngang -->
      <div class="action-list">
        <div v-for="action in actions" :key="action.name"
             class="action-item pointer"
             @click="handleAction(action)">
          <IconV2 :name="action.icon" class="me-1" />
          <span class="label">{{ action.label }}</span>
        </div>
      </div>

      <!-- Nút huỷ -->
      <div class="cancel-btn pointer" @click="cancelSelect">
        Huỷ
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedMessages: { type: Array, default: () => [] },
    pinMessages: { type: Array, default: () => [] }
  },
  data() {
    return {
      visible: false,
      x: 0,
      y: 0
    };
  },
  computed: {
    actions() {
      const msgs = this.selectedMessages;
      const pinMessages = this.pinMessages || [];
      if (!msgs || !msgs.length) return [];

      const isPinned = m => pinMessages.some(p => p.client_msg_id === m.cliMsgId);
      const allPinned = msgs.every(m => isPinned(m));
      const nonePinned = msgs.every(m => !isPinned(m));
      const mixedPinned = !allPinned && !nonePinned;

      return [
        { name: 'copy', label: 'Copy', icon: 'v2-copy', event: 'copy', visible: msgs.every(m => ['webchat'].includes(m.msgType)) },
        { name: 'forward', label: 'Chuyển tiếp', icon: 'v2-share', event: 'forward', visible: msgs.some(m => m.isShowMessageSharePopup) },
        { name: 'pin', label: allPinned ? 'Bỏ ghim' : 'Ghim', icon: 'v2-mark1', event: 'togglePin', visible: msgs.every(m => m.isCanPin) && !mixedPinned },
        { name: 'downloadImage', label: 'Lưu ảnh', icon: 'v2-import', event: 'downloadImage', visible: msgs.some(m => m.msgType === 'chat.photo') },
        { name: 'undo', label: 'Thu hồi', icon: 'v2-reset', event: 'undoMessages', visible: msgs.every(m => m.isShowUndoIcon && !m.checkUndoMessage && !m.checkDeleteMessage && m.id.uidFrom === '0') },
        { name: 'delete', label: 'Xoá', icon: 'el-icon-delete', event: 'delete', visible: msgs.some(m => m.isShowDelete && !m.checkDeleteMessage) }
      ].filter(a => a.visible);
    }
  },
  methods: {
    showPopover() {
      this.visible = true;
    },
    hidePopover() { this.visible = false; },
    handleAction(action) {
      const msgs = this.selectedMessages;
      if (action.name === 'pin') {
        const pinMessages = this.pinMessages || [];
        const allPinned = msgs.every(m => pinMessages.some(p => p.client_msg_id === m.cliMsgId));
        this.$emit(action.event, { messages: msgs, isPin: !allPinned });
      } else {
        this.$emit(action.event, msgs);
      }
      this.hidePopover();
    },
    handleClickOutside(e) {
      const popoverEl = this.$el.querySelector('.multi-message-toolbar');
      if (popoverEl && !popoverEl.contains(e.target)) this.hidePopover();
    },
    cancelSelect() {
      this.$emit('cancelSelect');
    }
  },
  mounted() {
    document.addEventListener('mousedown', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
};
</script>

<style scoped>
.multi-message-toolbar {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  padding: 6px 10px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.12);
  gap: 12px;
  z-index: 9999;
}

.selected-count {
  font-size: 13px;
  color: #555;
  font-weight: 500;
}

.action-list {
  display: flex;
  gap: 12px;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.action-item {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  cursor: pointer;
  border-radius: 6px;
  transition: background-color 0.2s;
}

.action-item:hover {
  background-color: #f0f2f5;
}

.cancel-btn {
  padding: 4px 10px;
  cursor: pointer;
  font-weight: 500;
  color: #ff4d4f;
  border-radius: 6px;
  transition: background-color 0.2s;
}

.cancel-btn:hover {
  background-color: #ffe6e6;
}
</style>
